export enum QuestionStrategyEnum {
  STANDARD = 'STANDARD',
  RANDOM_FIXED = 'RANDOM_FIXED',
  RANDOM_EVERY_TIME = 'RANDOM_EVERY_TIME',
}
